/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2020 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
*/

@import '@spectrum/spectrum-variables/stylus/spectrum-light.styl'

:local(.root)
  display flex
  width 100%
  height 100%

:local(.settingsNav)
  flex-grow 0
  flex-shrink 0
  margin-top 20px
  height calc(100% - 20px)
  border-right solid 1px $spectrum-alias-dropshadow-color

:local(.contentArea)
  flex-grow 10
  height 100%
  margin-left 30px
  overflow-y scroll

:local(.navItem)
  width 200px

